<template>
  <Wrapper>
    <Dashboard>
      <DomicileAddressStep
        :city="session.domicileAddress?.city"
        :country="session.domicileAddress?.country"
        :number="session.domicileAddress?.number"
        :postal-code="session.domicileAddress?.postalCode"
        :show-cancel-button="true"
        :street="session.domicileAddress?.street"
        :sub-title="'ident.steps.domicile_address.sub_title'"
        :title="'ident.steps.domicile_address.title'"
        @next="handleNext"
      />
    </Dashboard>
  </Wrapper>
</template>

<script setup lang="ts">
import { toast } from 'vue-sonner'
import { DomicileAddress, StepNavigation } from '@/types'
import { useNaturalPersonsDomicile } from '@/composables/api/use-natural-persons-domicile.ts'
import { useUserSession } from '@/composables/use-user-session.ts'
import DomicileAddressStep from '@/components/ident/steps/personal-data/DomicileAddressStep.vue'
import Dashboard from '@/components/wrappers/Dashboard.vue'
import Wrapper from '@/components/wrappers/Wrapper.vue'

definePage({
  name: 'edit-address',
  meta: {
    titleKey: 'tab.edit_address',
    requiresAuth: true,
  },
})

const { t } = useI18n()
const router = useRouter()
const { session } = useUserSession()
const { updateNaturalPersonsDomicile } = useNaturalPersonsDomicile()

async function handleNext(eventData?: StepNavigation<DomicileAddress>) {
  const personUid = session.value.personUid
  const data = eventData?.data
  if (!personUid || !data) return

  try {
    await updateNaturalPersonsDomicile(personUid, {
      agentAddress: {
        street: data.street,
        number: data.number,
        postalCode: data.postalCode,
        city: data.city,
        country: data.country,
      },
    })
  } catch {
    return
  }

  toast.success(t('settings.edit.success'))
  router.push({ name: 'settings' })
}
</script>
